import { OptionGrid } from "@ui/components/OptionGrid";
import type { SupportedCurrency } from "@ui/lib/locale-data";

interface CurrencyGridProps {
  currencies: SupportedCurrency[];
  currentCurrency: string;
  onSelect: (code: string) => void;
  /** Accessible name for the grid's radio group (the section heading's text). */
  ariaLabel: string;
}

export function CurrencyGrid({ currencies, currentCurrency, onSelect, ariaLabel }: CurrencyGridProps) {
  return (
    <OptionGrid
      ariaLabel={ariaLabel}
      items={currencies.map((currency) => ({
        id: currency.code,
        primary: currency.name,
        secondary: `${currency.code} – ${currency.symbol}`,
      }))}
      onSelect={onSelect}
      selectedId={currentCurrency}
    />
  );
}
